module.exports = __webpack_public_path__ + "img/frame (288).bed5ba40.jpg";